import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./footer.module.scss";
const Footer = ({ left, right, className }) => (React.createElement("footer", { className: getClassName(styles.root, className) },
    React.createElement("div", null, left),
    React.createElement("div", null, right)));
export default Footer;
//# sourceMappingURL=Footer.js.map